/* esm.sh - applesauce-core@5.2.0/dist/logger */
export * from "/*applesauce-core@5.2.0/esnext/dist/logger.mjs";
